/**
 * FlightModal.jsx - 항공 신규/수정 모달 (Phase 3-C, 2026-04-30)
 */
import React, { useState } from 'react';
import { apiClient } from '../../../api/apiClient';
import { validateReservationForm } from '../reservationFormValidation';
import { useReservationFieldSettings } from '../useReservationFieldSettings';
import { Field, Modal, Grid, PAX_OPTS } from './_modal-helpers';

function flightTotal(row = {}) {
  return Number(row.base_fare || 0) + Number(row.fuel_surcharge || 0) + Number(row.taxes || 0);
}

function cleanFlightPayload(row = {}) {
  const { notes, ...payload } = row;
  return { ...payload, total_payment: flightTotal(payload) };
}

export default function FlightModal({ travelCode, row, onClose, onSaved }) {
  const isNew = !row;
  const [form, setForm] = useState(row ? { ...row } : {});
  const [saving, setSaving] = useState(false);
  const { hiddenSet } = useReservationFieldSettings();
  const showField = (key) => !hiddenSet.has(key);
  const upd = (k) => (v) => setForm((f) => {
    const next = { ...f, [k]: v };
    if (['base_fare', 'fuel_surcharge', 'taxes'].includes(k)) next.total_payment = flightTotal(next);
    return next;
  });

  async function handleSave() {
    const validationMessage = validateReservationForm({
      master: { travel_code: travelCode, customer_name: '-', reservation_date: '-' },
      flights: [form],
      cars: [],
      hotels: [],
      isVisible: showField,
    });
    if (validationMessage) { alert(validationMessage); return; }

    setSaving(true);
    try {
      const payload = cleanFlightPayload(form);
      const r = isNew
        ? await apiClient.post(`/api/admin/reservations/${encodeURIComponent(travelCode)}/flights`, payload)
        : await apiClient.put(`/api/admin/flight-bookings/${row.id}`, payload);
      if (r.ok && r.data?.success) { onSaved && onSaved(); onClose(); }
      else alert(r.data?.message || '저장 실패');
    } catch (e) { alert('오류: ' + e.message); }
    finally { setSaving(false); }
  }

  return (
    <Modal title={isNew ? '항공편 추가' : `항공편 수정 #${row.id}`} onClose={onClose} onSave={handleSave} saving={saving}>
      <Grid>
        {showField('flight.passenger_type') && <Field label="구분" required value={form.passenger_type} onChange={upd('passenger_type')} options={PAX_OPTS} />}
        {showField('flight.total_payment') && <Field label="총결제금액" required readOnly type="amount" value={flightTotal(form)} onChange={() => {}} />}
        {showField('flight.base_fare') && <Field label="항공운임" required type="amount" value={form.base_fare} onChange={upd('base_fare')} />}
        {showField('flight.fuel_surcharge') && <Field label="유류할증료" required type="amount" value={form.fuel_surcharge} onChange={upd('fuel_surcharge')} />}
        {showField('flight.taxes') && <Field label="공항세" required type="amount" value={form.taxes} onChange={upd('taxes')} />}
        {showField('flight.airline') && <Field label="항공사" value={form.airline} onChange={upd('airline')} />}
        {showField('flight.flight_number') && <Field label="편명" value={form.flight_number} onChange={upd('flight_number')} />}
        {showField('flight.departure_airport') && <Field label="출발공항" value={form.departure_airport} onChange={upd('departure_airport')} />}
        {showField('flight.arrival_airport') && <Field label="도착공항" value={form.arrival_airport} onChange={upd('arrival_airport')} />}
        {showField('flight.departure_at') && <Field label="출발 (YYYY-MM-DD HH:mm)" value={form.departure_at} onChange={upd('departure_at')} />}
        {showField('flight.arrival_at') && <Field label="도착 (YYYY-MM-DD HH:mm)" value={form.arrival_at} onChange={upd('arrival_at')} />}
        {showField('flight.departure_raw') && <Field label="출발 원본" value={form.departure_raw} onChange={upd('departure_raw')} />}
        {showField('flight.arrival_raw') && <Field label="도착 원본" value={form.arrival_raw} onChange={upd('arrival_raw')} />}
        {showField('flight.passenger_name') && <Field label="탑승자명" value={form.passenger_name} onChange={upd('passenger_name')} />}
        {showField('flight.seat_no') && <Field label="좌석" value={form.seat_no} onChange={upd('seat_no')} />}
      </Grid>
    </Modal>
  );
}
